var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-box {\r\n    height: 100%;\r\n    position: fixed;\r\n    background: url(" + escape(require("../../../assets/images/error-bg.jpg")) + ") no-repeat center center #fff;\r\n    width: 100%; }\r\n    .error-box .footer {\r\n      width: 100%;\r\n      left: 0px;\r\n      right: 0px; }\r\n  \r\n  .error-body {\r\n    padding-top: 5%; }\r\n    .error-body h1 {\r\n      font-size: 210px;\r\n      font-weight: 900;\r\n      text-shadow: 4px 4px 0 #ffffff, 6px 6px 0 #263238;\r\n      line-height: 210px; }\r\n  ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/app/components/nopagefound/nopagefound.component.css
// module id = ../../../../../src/app/components/nopagefound/nopagefound.component.css
// module chunks = main